export const FollowUpRecordType = {
    NOTE: 'note',
    EVENT: 'event',
    SUPPLIER_EMAIL: 'supplier_email',
    REPLY_TO_SUPPLIER_EMAIL: 'reply_to_supplier_email',
};
